import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, ControlContainer, UntypedFormControl, Validators } from '@angular/forms';
import { AppSettings } from 'pac-api';
import { Individual } from '../../model/individual';
import { WizardService } from '../../wizard/wizard.service';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class RecaptchaComponent implements OnInit {

  @Input() individual: Individual;
  @Input() isSaving: boolean;
  @Input() existing: boolean;
  @Input() form: UntypedFormGroup;


  constructor(private wizard: WizardService, public settings: AppSettings) { }

  ngOnInit() {
    const gRecaptchaResponse = new UntypedFormControl(null, [ Validators.required ]);
    const recaptcha = new UntypedFormGroup({ gRecaptchaResponse });
    this.form.addControl('recaptcha', recaptcha);
  }
}
